import {Form} from "../../../form/form";
import {GvfService} from "../../../../../gvf/js/gvf-service";
import {GvfUiService} from "../../../../../gvf/js/gvf-ui-service";
import {UtilsService} from "../../../../js/utils-service";

export class ModelUpdateFromValueAction extends Form{
    updateValueFormFields(){
        GvfService.endpoint(
            "/cp/base-model-data-field-detail/get-model-update-set-value-form",
            {fieldId:this.$fieldId.formFieldVal(),formData:this.$root.getValues()}
        ).then(
            (resp)=>{
                this.$root.find(".is-value-set-field").remove();
                const $fields = $(resp.html).find(".js-form-field");
                $fields.insertAfter(this.$fieldId);
                $fields.addClass("is-value-set-field");
                GvfUiService.init($fields);
                this.checkBindings();
            }
        ).catch(UtilsService.alertEndpointResponse);
    }

    ready(){
        super.ready();
        this.$fieldId = this.$root.findFormFieldByName("fieldId");
        this.$fieldId.on(
            "formField:changeVal",
            ()=>{
                this.updateValueFormFields();
            }
        );
    }
}

